import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { ReactTableDataGrid } from "components/Table";
import { ListDateType } from "helper/constant";
import { convertTZ, formatterCreateAt, isEmptyObject } from "components/Function";
import { getProductsByShops } from "actions/promotionv2Action";
import Loading from "components/Loading";
import cx from "classnames";
import SelectCustom from "components/elements/selectCustom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

const ProductByShop = ({
    promotionv2,
    formatterCreateAt,
    isEmptyObject,
    shops,
    getProductsByShops,
    product,
    formData,
    setFormData,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [filter, setFilter] = useState({});
    const [products_selected, setProductsSelected] = useState([]);
    const { t } = useTranslation();
    const { isLoading } = promotionv2;
    const { listproductsbyshops, totalsize_listproductsbyshops } = product;
    const [shop, setShop] = useState([]);
    const gridApiRef = useRef(null);

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalSize || 50,
        },
    ];

    useEffect(() => {
        setTotalSize(totalsize_listproductsbyshops);
    }, [totalsize_listproductsbyshops]);

    useEffect(() => {
        if (formData?.shop_id) {
            setShop([formData?.shop_id]);
        }
    }, [formData?.shop_id]);

    useEffect(() => {
        if (formData?.products) {
            var products_selected_tmp = formData?.products?.map((v, i) => ({ shopId: formData?.shop_id, apiProductId: v }));
            setProductsSelected(products_selected_tmp);
        }
    }, [formData?.products]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if ((shop.length === 0 || !shop) && formData?.shop_id) {
            return;
        }
        if (isEmptyObject(filter)) {
            return;
        }
        // if (formData?.product_level === "SHOP") {
        //     return;
        // }

        getProductsByShops({ page, sizeperpage: sizePerPage, search: searchText, filter, shops_selected: shop, shop_id: formData?.shop_id, promotionv2_id: formData?._id });
    }, [page, sizePerPage, searchText, filter]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
    }, [dateType]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (gridApiRef.current && products_selected.length > 0) {
            gridApiRef.current.forEachNode((node) => {
                const isSelected = products_selected.some(
                    (p) => p.apiProductId === node.data.apiProductId && p.shopId === node.data.shopId
                );
                if (isSelected) {
                    node.setSelected(true);
                }
            });
        }
    }, [listproductsbyshops]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeShop = (e) => {
        var shops_tmp = e.map((v, i) => {
            return v.value;
        });
        setShop(shops_tmp);
        setFormData((prev) => ({ ...prev, shops_selected: shops_tmp }));
    };

    const columns = [
        {
            field: 'apiProductId',
            headerName: "",
            sort: false,
            editable: false,
            cellClass: "centered-cell",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => ""
        },
        {
            field: "main_images",
            headerName: t("Main Images"),
            sort: false,
            editable: false,
            cellClass: "centered-cell",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <img src={cell?.[0] || require("components/assets/media/misc/image.png")} className="img-thumbnail" width={100} alt="" />
        },
        {
            field: "title",
            headerName: t("Title"),
            sort: false,
            editable: false,
            width: 550,
        },
        {
            field: "shopId",
            headerName: t("Shop"),
            sort: false,
            editable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => shops?.find((v, i) => v?._id === cell)?.name || ""
        },
    ];

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const onSelectionChanged = (data) => {
        if (data.api && !formData.check_all_products) {
            const selectedRows = data.api.getSelectedRows().map((d) => ({
                apiProductId: d.apiProductId,
                shopId: d.shopId,
            }));

            setProductsSelected((prev) => {
                const currentPageIds = data.api.getRenderedNodes().map((n) => ({
                    apiProductId: n.data.apiProductId,
                    shopId: n.data.shopId,
                }));

                const filteredPrev = prev.filter((p) => !currentPageIds.some((c) => c.apiProductId === p.apiProductId && c.shopId === p.shopId));

                const merged = [...filteredPrev, ...selectedRows];

                const unique = merged.filter((v, i, a) => a.findIndex((t) => t.apiProductId === v.apiProductId && t.shopId === v.shopId) === i);

                setFormData((prevForm) => ({
                    ...prevForm,
                    products_selected: unique,
                }));

                return unique;
            });
        }
    };

    const handleLoadProduct = () => {
        setProductsSelected([]);
        setFormData((prev) => ({ ...prev, products_selected: [], check_all_products: false }));
        if (gridApiRef.current) {
            gridApiRef.current.deselectAll();
        }
        getProductsByShops({ page, sizeperpage: sizePerPage, search: searchText, filter, shops_selected: shop, shop_id: formData?.shop_id });
    };

    const onClickSelectAllProducts = async () => {
        setProductsSelected([]);
        setFormData((prev) => ({ ...prev, products_selected: [], check_all_products: !formData.check_all_products }));
        if (gridApiRef.current) {
            gridApiRef.current.deselectAll();
        }
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5">
                    <button onClick={handleLoadProduct} className="btn btn-danger btn-sm me-2">
                        {t("Load Product")}
                    </button>
                    <button onClick={() => { onClickSelectAllProducts() }} type="button" className={cx("btn btn-sm me-2", { "btn-secondary": !formData.check_all_products, "btn-success": formData.check_all_products })}>
                        <i className={cx("ki-outline fs-2", { "ki-cross-square": !formData.check_all_products, "ki-check-square": formData.check_all_products })}></i> {t("Select all products")}
                    </button>
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const onGridReady = (params) => {
        gridApiRef.current = params.api;
    };

    return (
        <div className="card min-w-full">
            <Loading isLoading={isLoading} />
            <div className="card-body">
                <div className="form-group mb-5">
                    {/* <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                        <span className="required">{t("Select Shop")}</span>
                    </label> */}
                    <div>
                        <SelectCustom
                            options={shops?.map((s) => { return { value: s._id.toString(), label: `${s.name} - ${s.note} - ${s.code}` } })}
                            value={shops?.map((s) => { return { value: s._id.toString(), label: `${s.name} - ${s.note} - ${s.code}` } })?.filter(({ value }) => shop.includes(value))}
                            onChange={onChangeShop}
                            placeholder={t("Select a shop code ... ")}
                            className="w-100"
                            shortValue={false}
                            isDisabled={formData?.shop_id ? true : false}
                        />
                    </div>
                </div>
                <div className={cx("al-variants-table al-max-height-table-cus", { "d-none": formData?.product_level === "SHOP" })}>
                    <ReactTableDataGrid
                        tableName="productByShop"
                        idProperty="_id"
                        columns={columns}
                        rowData={listproductsbyshops}
                        gridOptions={{
                            rowHeight: 150,
                            // reactiveCustomComponents: true,
                        }}
                        paginationPageSize={sizePerPage}
                        totalSize={totalSize}
                        onTableChanged={onTableChanged}
                        emptyText={t("No data!")}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChanged}
                        sizePerPageList={sizePerPageList}
                        groupButton={groupButton}
                        className={cx({ "al-disabled": formData.check_all_products })}
                        onGridReady={onGridReady}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ promotionv2, product }) => ({ promotionv2, product });
const mapDispatchToProps = {
    formatterCreateAt,
    getProductsByShops,
    isEmptyObject,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductByShop);
